import { render, staticRenderFns } from "./cjContentDetail.vue?vue&type=template&id=6f77859e&scoped=true"
import script from "./cjContentDetail.vue?vue&type=script&lang=js"
export * from "./cjContentDetail.vue?vue&type=script&lang=js"
import style0 from "./cjContentDetail.vue?vue&type=style&index=0&id=6f77859e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f77859e",
  null
  
)

export default component.exports